<div class="user-avatar relative">
  <p-avatar
    [image]="imgSrc()"
    [label]="label()"
    [icon]="icon()"
    [styleClass]="'avatar-' + size()"
    [shape]="shape()" />
  @if (showActiveIndicator()) {
    <span
      [class]="'status-indicator ' + 'size-' + size()"
      [ngClass]="{ active: active() }"></span>
  }
</div>
